<section class="ioh-level-one-dashboard" aria-label="Operations Summary">
  <div class="ioh-level-one-dashboard-zoom">
  <header class="ioh-dashboard-header">
    <div class="flex align-items-center gap-10">
      <h1>Operations Summary</h1>
      <span>Intermodal Data as of Today, {{ currentDate | date: 'MM/dd/yyyy @ HH:mm' }}</span>
    </div>
  </header>

  <div class="ioh-summary-grid">
    <article class="ioh-summary-card"><span>Total Inbound Trains</span><strong><i class="metric-dot good"></i>{{ totalInboundTrains() }}</strong>
    </article>
    <article class="ioh-summary-card"><span>Total Outbound Trains</span><strong><i class="metric-dot warn"></i>{{ totalOutboundTrains() }}</strong>
    </article>
    <article class="ioh-summary-card"><span>Avg Gate Dwell</span><strong><i class="metric-dot" [ngClass]="(iohGateInfo?.totals?.avgTurnTimeMinutes || 0) > env.appConfig.iohGateAvgTurnTimeMints ? 'bad' : 'good'"></i>{{ avgGateDwell() }}</strong>
    </article>
    <article class="ioh-summary-card"><span>Primary Lifts</span><strong><i class="metric-dot good"></i>{{ totalLifts() }}</strong>
    </article>
    <article class="ioh-summary-card"><span>Left On Ground</span><strong><i class="metric-dot warn"></i>{{ totalLogs() }}</strong>
    </article>
    <article class="ioh-summary-card"><span>Total Bookings</span><strong><i class="metric-dot info"></i>{{ totalBookings() }}</strong>
    </article>
  </div>

  <div class="ioh-terminal-view-header">
    <h2>Terminal Operations</h2>
    <div class="ioh-terminal-tabs" role="tablist" aria-label="Terminal operations filters">
       <button type="button" role="tab" [attr.aria-selected]="dashboardTab === 'equipment'" [class.active]="dashboardTab === 'equipment'" (click)="setDashboardTab('equipment')">Equipment</button>
       <button type="button" role="tab" [attr.aria-selected]="dashboardTab === 'gate'" [class.active]="dashboardTab === 'gate'" (click)="setDashboardTab('gate')">Gate</button>
       <button type="button" role="tab" [attr.aria-selected]="dashboardTab === 'trains'" [class.active]="dashboardTab === 'trains'" (click)="setDashboardTab('trains')">Trains</button>
     </div>
  </div>

  <div class="ioh-terminal-dashboard-body">
    <div class="ioh-dashboard-map" aria-label="Intermodal terminal map" #mapSlot></div>
    <div class="ioh-terminal-card-grid">
      <article *ngFor="let terminal of terminals; let i = index" class="ioh-terminal-card" [class.has-popup]="terminal.showEquipmentInfo || terminal.showGateInfo || terminal.showTrainInfo">
        <div class="terminal-card-header" (click)="onDashboardCardHeaderClick(terminal, $event)">
          <div class="terminal-card-heading"><strong>{{ getTerminalCode(terminal.code) }}</strong></div>
          <span class="terminal-card-name">{{ terminal.name }}</span> 
        </div>
        <div class="terminal-card-rule"></div>
        <div class="terminal-card-body" (click)="onDashboardCardBodyClick(terminal, $event)">
          <ng-container [ngSwitch]="dashboardTab">
            <span *ngSwitchCase="'equipment'" class="dashboard-card-detail">Equipment</span>
            <ng-container *ngSwitchCase="'equipment'">
              <ng-container *ngIf="getEquipmentMeterData(terminal) as equipmentMeter">
                <p-meterGroup class="equipment-meter" [value]="equipmentMeter.values" [max]="equipmentMeter.max" labelPosition="end" labelOrientation="horizontal">
                  <ng-template #label let-value>
                    <div class="meter-label-list">
                      <div class="meter-label-item" *ngFor="let item of value">
                        <div class="meter-label-top">
                          <span class="meter-label-marker" [ngStyle]="{ backgroundColor: item.color }"></span>
                          <strong class="meter-label-value" [ngStyle]="{ color: item.color }">{{ item.value }}</strong>
                        </div>
                        <span class="meter-label-text">{{ item.label }}</span>
                      </div>
                    </div>
                  </ng-template>
                </p-meterGroup>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'gate'"><span class="dashboard-card-detail">Average Turn Time</span><div class="gate-metric"><strong>{{ formatGateTime(getGateMetrics(terminal).average) }}</strong><span class="gate-pill" [ngClass]="gateStatus(getGateMetrics(terminal).average).toLowerCase()">{{ gateStatus(getGateMetrics(terminal).average) }}</span></div><small class="moves-label"><i class="metric-dot" [ngClass]="gateStatus(getGateMetrics(terminal).average).toLowerCase()"></i>{{ getGateMetrics(terminal).moves }} Total Moves</small></ng-container>
            <ng-container *ngSwitchCase="'trains'">
              <span class="dashboard-card-detail">Trains</span>
              <ng-container *ngIf="getTrainMeterData(terminal) as trainMeter">
                <p-meterGroup class="train-meter" [value]="trainMeter.values" [max]="trainMeter.max" labelPosition="end" labelOrientation="horizontal">
                  <ng-template #label let-value>
                    <div class="meter-label-list">
                      <div class="meter-label-item" *ngFor="let item of value">
                        <div class="meter-label-top">
                          <span class="meter-label-marker" [ngStyle]="{ backgroundColor: item.color }"></span>
                          <strong class="meter-label-value" [ngStyle]="{ color: item.color }">{{ item.value }}</strong>
                        </div>
                        <span class="meter-label-text">{{ item.label }}</span>
                      </div>
                    </div>
                  </ng-template>
                </p-meterGroup>
              </ng-container>
            </ng-container>
            <span *ngSwitchDefault class="terminal-status" [ngClass]="terminalStatusClass(terminal)">{{ terminalStatus(terminal) }}</span>
          </ng-container>
        </div>
        @if (terminal.showEquipmentInfo) {
        <ioh-csx-terminal-equipment
          [terminalName]="terminal.name"
          [terminalAbbreviation]="terminal.code"
          [trains]="terminal.awaitingDepartureTrains"
          [terminalTrains]="terminal.trainAwaitingDeparture"
          [terminalMetric]="terminal.terminalMetric"
          [showClose]="true"
          [(close)]="terminal.showEquipmentInfo"
          [level]="level"
          [terminalUid]="terminal.schematicId + '-dashboard-equipment'"
          [showFilter]="iohShowFilter"
          [equipmentResponse]="iohEquipmentInfo"
          [clickPoint]="terminal.popupClickPoint"
          [bounds]="terminal.popupBounds"
        ></ioh-csx-terminal-equipment>
        }
        @if (terminal.showGateInfo) {
        <ioh-csx-terminal-gate
          [terminalName]="terminal.name"
          [terminalAbbreviation]="getTerminalCode(terminal.code)"
          [showClose]="true"
          [(close)]="terminal.showGateInfo"
          [level]="level"
          [terminalUid]="terminal?.schematicId + '-dashboard-gate'"
          [showFilter]="iohShowFilter"
          [gateResponse]="iohGateInfo?.terminals?.[getTerminalCode(terminal.code)]"
          [clickPoint]="terminal.popupClickPoint"
          [bounds]="terminal.popupBounds"
        ></ioh-csx-terminal-gate>
        }
        @if (terminal.showTrainInfo) {
        <ioh-csx-terminal-train
          [terminalName]="terminal.name"
          [terminalAbbreviation]="terminal.code"
          [trains]="terminal.awaitingDepartureTrains"
          [terminalTrains]="terminal.trainAwaitingDeparture"
          [terminalMetric]="terminal.terminalMetric"
          [showClose]="true"
          [(close)]="terminal.showTrainInfo"
          [level]="level"
          [terminalUid]="terminal?.schematicId + '-dashboard-train'"
          [showFilter]="iohShowFilter"
          [trainResponse]="iohTrainInfo && iohTrainInfo.terminals?.[terminal.milepost]"
          [clickPoint]="terminal.popupClickPoint"
          [bounds]="terminal.popupBounds"
        ></ioh-csx-terminal-train>
        }
      </article>
    </div>
  </div>
  </div>
</section>
